(function(angular){
	'use strict';
	
	angular
		.module('formValidationModule')
		.directive('requiredSelect', [
			'$parse',
			requiredSelectFunction
		]);
	
	function requiredSelectFunction($parse) {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function($scope, $elem, $attrs, ngModel) {

				var model;
				var isValid;

				function checkValidity() {
					model = $parse($attrs.ngModel)($scope);
					isValid = angular.isDefined(model) && angular.isDefined(model.value);
					ngModel.$setValidity('required', isValid);
				}

				$scope.$watch($attrs.ngModel, function() {
					checkValidity();
				});
			}
		};
	}
})(window.angular);